import type { GenUiEntry } from '../../shared/ui/registry.js';
import type { NextServicesBlockMap, NextServicesProduct } from '@voll-intelligence/genui-contract';
import { NextServicesView } from './ui/next_services_view.js';

/** A entrada de catálogo do `<produto>_next_services` — slot `chat`, sem
 *  challenge: cada linha manda o pedido do próximo serviço por `reply`. O host
 *  adota o bloco (recibo provisório + painel da viagem) mesmo quando ele não
 *  desenha. */
function nextServicesEntry<P extends NextServicesProduct>(
  product: P,
  kind: NextServicesBlockMap[P]['kind'],
): GenUiEntry<NextServicesBlockMap[P]> {
  return {
    kind,
    slot: 'chat',
    policy: { productOf: () => product },
    render: ({ ui, dispatch, readOnly }) => (
      <NextServicesView product={product} ui={ui} dispatch={dispatch} readOnly={readOnly} />
    ),
  };
}

export const flightNextServicesEntry = nextServicesEntry('flight', 'flight_next_services');
export const hotelNextServicesEntry = nextServicesEntry('hotel', 'hotel_next_services');
export const busNextServicesEntry = nextServicesEntry('bus', 'bus_next_services');
export const rentalNextServicesEntry = nextServicesEntry('rental', 'rental_next_services');
export const mobilityNextServicesEntry = nextServicesEntry('mobility', 'mobility_next_services');
